import { WeaTools } from "ecCom";

// const callAPI = WeaTools.callAPI;

const getMsgTypeNumberList = params =>
  WeaTools.callApi(
    "/api/msgcenter/homepage/getMsgTypeNumberList",
    "GET",
    params
  );
const getNewMsgTypeNumberList = params =>
  WeaTools.callApi(
    "/api/msgcenter/homepage/getNewMsgTypeNumberList",
    "GET",
    params
  );
const getMsgList = params =>
  WeaTools.callApi("/api/msgcenter/homepage/getMsgList", "POST", params);
const getNewMsgList = params =>
  WeaTools.callApi("/api/msgcenter/homepage/getNewMsgList", "POST", params);
const getPopList = params =>
  WeaTools.callApi("/api/msgcenter/homepage/getPopList", "GET", params);
const getMsgCount = params =>
  WeaTools.callApi("/api/msgcenter/homepage/getMsgCount", "GET", params);
const setMsgRead = params =>
  WeaTools.callApi("/api/msgcenter/homepage/setMsgRead", "GET", params);
const getModule = params =>
  WeaTools.callApi("/api/msgcenter/homepage/getModule", "GET", params);
const stickMsgType = params =>
  WeaTools.callApi("/api/msgcenter/homepage/stickMsgType", "POST", params);
const cancelStickMsgType = params =>
  WeaTools.callApi(
    "/api/msgcenter/homepage/cancelStickMsgType",
    "POST",
    params
  );

export {
  getModule,
  getMsgList,
  getNewMsgList,
  getMsgTypeNumberList,
  getNewMsgTypeNumberList,
  getPopList,
  getMsgCount,
  setMsgRead,
  stickMsgType,
  cancelStickMsgType
};



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/apis/index.js